import { useTracking } from '@act/react-components/tracking';
import { Button } from '@act/storybook';
import { Box, DialogActions, Divider } from '@mui/material';

interface SubmittableDialogActionsProps {
  cancelText?: string;
  submissionText?: string;
  isValid?: boolean;
  disabled?: boolean;
  ignoreIsValid?: boolean;
  handleClose: () => void;
  handleSubmission: () => void;
  handleDelete?: () => void;
}

const SubmittableDialogActions = ({
  cancelText = 'Cancel',
  submissionText = 'Submit',
  disabled = false,
  isValid = true,
  ignoreIsValid = false,
  handleClose,
  handleSubmission,
  handleDelete,
}: SubmittableDialogActionsProps) => {
  const { generateTrackingProps } = useTracking();
  return (
    <Box>
      <Divider />
      <DialogActions
        sx={{
          padding: '8px 24px',
        }}
      >
        {handleDelete && (
          <Button
            disabled={disabled}
            onClick={handleDelete}
            variant="text"
            sx={{ marginRight: 'auto' }}
            {...generateTrackingProps('delete-button')}
          >
            Delete
          </Button>
        )}
        <Button
          disabled={disabled}
          onClick={handleClose}
          variant="text"
          {...generateTrackingProps('cancel-button')}
        >
          {cancelText}
        </Button>
        <Button
          onClick={handleSubmission}
          variant="contained"
          debounced
          disabled={(!isValid && !ignoreIsValid) || disabled}
          {...generateTrackingProps('submit-button')}
        >
          {submissionText}
        </Button>
      </DialogActions>
    </Box>
  );
};

export default SubmittableDialogActions;
